<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        page: {
          currentPage: 1,
          total: 0,
          pageSize: 20
        },
        url: '/admin',
        // 表格数据
        data: [],
        // curd组件
        option: {
          viewBtn: false, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText: '新增管理员', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '账户',
              prop: 'username',
              span: 14,
              rules: [{
                type: 'string', required: true, message: '账户不能为空', trigger: 'blur'
              }],
              search: true
            },
            {
              label: '密码',
              prop: 'password',
              type: 'password',
              span: 14,
              rules: [
                {type: 'string', required: false, message: '密码', trigger: 'blur'},
                {min: 6, max: 20, message: '长度在6 到20 个字符'}
              ],
              tip: '创建管理员是密码为必填项; 修改时留空则不修改密码',
              // 以下两个属性同时使用可以彻底不在列表中显示
              hide: true, // 隐藏列
              showColumn: false // 是否加入动态现隐列
            },
            {
              label: '角色',
              prop: 'role_id',
              type: 'select',
              props: {
                label: 'display_name',
                value: 'id'
              },
              dicUrl: this.config.baseURL + '/dic/role',
              rules: [{
                type: 'number', required: true, message: '请选择所属角色', trigger: 'blur'
              }],
              search: true
            },
            {
              label: '角色描述',
              span: 24,
              display: false,
              prop: 'role-description'
            },
            {
              label: '备注',
              type: 'textarea',
              span: 24,
              prop: 'notes'
            }
          ]
        }
      }
    }
  }
</script>
